import { upsertHiddenInput } from '../../../dom/create';
import { isMapMode } from '../../util';

export function onDYSButtonClick( form: HTMLFormElement, eventTarget: EventTarget ): void {
    if ( !isMapMode() ) {
        upsertHiddenInput( form, 'destination', 'draw-your-search' );
        form.submit();
    } else {
        eventTarget.dispatchEvent( new CustomEvent( 'twc:mapsearch:draw-your-search:activate', { bubbles: true } ) );
    }
}
